import styled from 'styled-components'

import { Grid } from 'components/Core'

export const InvoiceContainer = styled.div`
  margin-top: calc(var(--actual-navbar-top-displacement) + 40px);
`

export const InvoiceHeader = styled.div`
  background-color: var(--color-secondary-200);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  font-family: var(--font-family-alpha);
  .title {
    font-weight: var(--font-weight-semibold);
    font-size: var(--size-font-medium);
    display: flex;
    align-items: center;
    column-gap: 6px;
  }
  .info {
    font-size: var(--size-font-extrasmall);
    font-style: italic;
    color: var(--color-primary-800);
  }
`

export const InvoiceInfoRow = styled.div<{ showDownloadInvoice: boolean }>`
  display: grid;
  grid-template-columns: repeat(
    ${({ showDownloadInvoice }) => (showDownloadInvoice ? 5 : 4)},
    1fr
  );
  padding-top: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--color-primary-100);
  margin-bottom: 24px;
  .title {
    font-size: var(--size-font-small);
    color: var(--color-primary-400);
  }
  .info {
    color: var(--color-primary-800);
  }
  > div:not(:last-of-type) {
    border-right: 1px solid var(--color-primary-100);
    min-height: 56px;
  }
  > div:not(:first-of-type) {
    padding-left: 32px;
  }
  > div:first-of-type {
    padding-left: 20px;
  }
`

export const ContainerRow = styled(Grid.Row)`
  @media (max-width: 1366px) {
    display: flex;
    flex-direction: column-reverse;
    row-gap: 20px;
  }
`

export const WarningBannerWrapper = styled.div`
  margin-bottom: 16px;
`
